module.exports = require("./es-BO.d.ts");